import { render, staticRenderFns } from "./SkeletonTable.vue?vue&type=template&id=6137ce5f&scoped=true"
import script from "./SkeletonTable.vue?vue&type=script&lang=ts"
export * from "./SkeletonTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137ce5f",
  null
  
)

export default component.exports